import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';

import Loader from "../Loader";

export default class UserDetails extends Component {

    render() {
        const { show, onHide, data, loading } = this.props;
        return (
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        User Details 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading && !data.commissions ? (
                        <Loader show={loading} noOverlay />
                    ) : (
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                <div className="form-group">
                                    <label>Name</label>
                                    <p>{data.name}</p>
                                </div>
                            </div>
                            <div className="col-md-6 mb-2">
                                <div className="form-group">
                                    <label>Phone</label>
                                    <p>{'+'+data.countryCode+'-'+data.phoneNumber}</p>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Order ID</th>
                                            <th>Commision</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.commissions && data.commissions.length && data.commissions.map(c => (
                                            <tr key={c.id}>
                                                <td>{c.id}</td>
                                                <td>{c.commission.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="row">
                                    <div className="col-md-7"/>
                                    <div className="col-md-4">
                                        <div className="d-flex">
                                            <div className="flex-1">
                                                <h4>Total:</h4>
                                            </div>
                                            <div className="flex-1 d-flex justify-content-end">
                                               <h4> {((data.commissions || []).reduce((total, c) =>  {
                                                   total = total + c.commission
                                                   return total;
                                               }, 0) || 0).toFixed(2)}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={onHide}>Close</button>
                </Modal.Footer>
            </Modal>
        )
    }
};